import React, { useEffect } from "react";
import { useQuery } from "@apollo/react-hooks";
import moment from "moment";
import { hasuraClient } from "../../apolloClient";
import { GET_EVENT_BY_ID } from "../../query/GetEventById";

import CreateEvent from "./CreateEvent";

const EditEvent = (props) => {
  const { id } = props.match.params;

  const { data } = useQuery(GET_EVENT_BY_ID, {
    client: hasuraClient,
    variables: {
      id: id,
      userId: localStorage.getItem("user_id"),
      current_date_time: moment().format(),
    },
  });

  return <CreateEvent editMode={true} data={data ? data : null} />;
};

export default EditEvent;
